// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"2a930f4b","364":"7296419e","453":"38ecae31","646":"ce84400b","713":"2dec6407"}[chunkId] + ".chunk.js";
};